import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface MetricCardProps {
  title: string;
  value: string | number;
  subValue?: string;
  icon?: React.ElementType;
  trend?: "up" | "down" | "neutral";
  trendValue?: string;
  className?: string;
}

export function MetricCard({ title, value, subValue, icon: Icon, trend, trendValue, className }: MetricCardProps) {
  return (
    <Card className={cn("overflow-hidden border-none shadow-sm hover:shadow-md transition-all duration-300", className)}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between space-y-0 pb-2">
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider">{title}</p>
          {Icon && <Icon className="h-4 w-4 text-muted-foreground/70" />}
        </div>
        <div className="flex items-end gap-2 mt-2">
          <div className="text-3xl font-bold font-heading text-foreground">{value}</div>
          {subValue && <div className="text-sm text-muted-foreground mb-1 font-medium">{subValue}</div>}
        </div>
        {trendValue && (
          <div className={cn("text-xs mt-3 flex items-center font-medium", 
            trend === "up" ? "text-emerald-600" : trend === "down" ? "text-red-600" : "text-muted-foreground"
          )}>
            {trend === "up" && "↑"} {trend === "down" && "↓"} {trendValue}
          </div>
        )}
      </CardContent>
      {/* Decorative bottom bar */}
      <div className={cn("h-1 w-full", 
        trend === "up" ? "bg-emerald-500/50" : trend === "down" ? "bg-red-500/50" : "bg-primary/50"
      )} />
    </Card>
  );
}
